import React, { Component } from "react";
import PropTypes from "prop-types";
import { VideoPropTypes } from "../../constants/classPropTypes";
import Schedule from "./schedule";
import OnAir from "./onAir";
import Upcoming from "./upcoming";
import "./streamingInfo.scss";

class StreamingInfo extends Component {
  render() {
    const { videos, source } = this.props;

    const onAirVideo = videos.find(video => video.isOnAir);
    const upcomingVideo =
      !onAirVideo && videos.filter(video => video.isUpcoming).pop();

    return (
      <div className="text-center mb-60">
        {onAirVideo && <OnAir video={onAirVideo} />}
        {upcomingVideo && <Upcoming video={upcomingVideo} source={source} />}
        {!onAirVideo && !upcomingVideo && <Schedule />}
      </div>
    );
  }
}

StreamingInfo.propTypes = {
  videos: PropTypes.arrayOf(VideoPropTypes).isRequired,
  source: PropTypes.string.isRequired
};

export default StreamingInfo;
